module.exports = __webpack_public_path__ + "img/utility_sync_2.c905a8a5.jpg";